var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"grey lighten-4",staticStyle:{"background-color":"#f5f5f5"}},[_c('v-container',{staticClass:"d-flex align-center justify-center",staticStyle:{"min-height":"100vh","padding":"24px 16px"}},[_c('portal-busca-form',{staticStyle:{"width":"100%"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }